<template>
	<section>
		<!--工具条-->
		<el-col :span="24" style="padding-top:15px;padding-bottom:14px;border-bottom: 1px solid rgb(209, 219, 229);">
			<div>
				<label  style="width: 80px; text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">所属系统:</label>
				<el-select  v-model="filterForm.sysCode" placeholder="全部" style="width: 150px;">
					<el-option label="全部" value="all"></el-option>
					<el-option v-for="(item,index) in sysAppList"  v-bind:key="index"  :label="item.name" :value="item.key"></el-option>
				</el-select>
				<label  style="width: 80px;text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">所属项目:</label>
				<el-input  placeholder="请选择项目" suffix-icon="el-icon-date" style="width: 150px" @focus="showProjectTree" v-model="projectNames"></el-input>
				<el-dialog  title="项目归属" v-model="projectTreeDialogVisible" >
				<div style="">
					<el-input placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
					<el-tree class="filter-tree" :data="projectTree"  show-checkbox node-key="id" :default-checked-keys="projectTreeDefaultChecked" :filter-node-method="filterNode" ref="projectTree"></el-tree>
				</div>
				<div slot="footer" class="dialog-footer">
					<el-button @click="projectTreeOnCancel">取 消</el-button>
					<el-button type="primary" @click="projectTreeOnSubmit">确 定</el-button>
				</div>
				</el-dialog>
				<label  style="width: 80px; text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">点类型:</label>
				<el-select  v-model="filterForm.dataType" placeholder="全部" style="width: 150px;">
					<el-option label="全部" value="all"></el-option>
					<el-option label="AI" value="0"></el-option>
					<el-option label="DI" value="1"></el-option>
				</el-select>
				<label  style="width: 80px;text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">点搜索:</label>
				<el-input style="width: 180px;" placeholder="输入点名称/编号" v-model="filterForm.search_word">
				</el-input>
				<el-button style="margin-left: 15px;" @click="queryBtn()">查询</el-button>
			</div>
		</el-col>
		<el-col :span="24" class="toolbar" style="padding: 0px;padding-bottom:2px;margin: 5px 0px;">
			<el-button v-if="permissionNodeList.BA_add.hasEntitle == 1" @click="handleAdd">新增点</el-button>
			<el-button v-if="permissionNodeList.BA_del.hasEntitle == 1" @click="handleBatchDelete">删除点</el-button>
			<el-button v-if="permissionNodeList.BA_import.hasEntitle == 1" @click="handleBatchImport">批量导入</el-button>
			<el-button v-if="permissionNodeList.BA_export.hasEntitle == 1" @click="exportData">数据导出</el-button>
		</el-col>
		<el-dialog title="批量导入项目" v-model="batchImportDialogVisible" @close="cancelUpload">
			<el-upload :limit="1"  :on-exceed="handleUploadExceed" :action="uploadUrl"  :on-success="handleUploadSuccess" :on-error="handleUploadError"  :before-upload ="handleBeforeUpload" :headers="uploadHeader" ref="batchImportUpload" :auto-upload="false">
				<span>选取文件:&nbsp;&nbsp;&nbsp;&nbsp;</span><el-button size="small" type="primary">请选择</el-button>
				<a style="display:inline;padding-left:350px;color:#b0b1b3;text-decoration:underline;" v-on:click.stop.prevent="downloadTemplate">模版下载</a>
				<div slot="tip" style="margin-top:55px;" class="el-upload__tip">温馨提示:只能上传excel文件，且不超过20MB</div>
			</el-upload>
			<div slot="footer" class="dialog-footer">
				<el-button @click="cancelUpload">取 消</el-button>
				<el-button type="primary" @click="batchImportOnSubmit">确 定</el-button>
			</div>
        </el-dialog>

		<!--列表-->
		<el-table :data="list_data" size="mini" highlight-current-row v-loading="listLoading" @selection-change="selsChange" style="width: 100%;">
			<el-table-column  type="selection" width="50">
			</el-table-column>
			<el-table-column prop="projectName" label="所属项目" width="120" sortable>
			</el-table-column>
			<el-table-column prop="sn" label="点编号" width="160"  sortable>
			</el-table-column>
			<el-table-column prop="dataType" label="点类型" width="100" sortable>
			</el-table-column>
			<el-table-column prop="valueTypeName" label="数据类型" width="120" sortable>
			</el-table-column>
			<el-table-column prop="name" label="点名称" width="180" sortable>
			</el-table-column>
			<el-table-column prop="sysCodeName" label="所属系统" min-width="140" sortable>
			</el-table-column>
			<el-table-column label="操作" width="220">
				<template scope="scope">
					<el-button size="small" v-if="scope.row.alarmIgnoreAble == '0' && permissionNodeList.BA_shield.hasEntitle == 1"  @click="handleBlock(scope.$index, scope.row)">屏蔽</el-button>
					<el-button size="small" v-if="scope.row.alarmIgnoreAble == '1' && permissionNodeList.BA_shield.hasEntitle == 1" @click="handleUnBlock(scope.$index, scope.row)" style="color:#b0b1b3;" >已屏蔽</el-button>
					<el-button size="small" v-if="permissionNodeList.BA_conf.hasEntitle == 1" @click="handleSetting(scope.$index, scope.row)">配置</el-button>
					<el-button size="small"  v-if="permissionNodeList.BA_show.hasEntitle == 1" @click="handleShowSetting(scope.$index, scope.row)">查看配置</el-button>
					<el-button size="small" v-if="permissionNodeList.BA_edit.hasEntitle == 1" @click="handleEdit(scope.$index, scope.row)">修改</el-button>
				</template>
			</el-table-column>
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="15" :total="total" style="float:right;">
			</el-pagination>
		</el-col>

		<!--新增界面-->
		<el-dialog title="新增BA点位" v-model="addFormVisible" :close-on-click-modal="false" @close="cancelAddSubmit">
			<el-form :model="addForm" label-width="120px" :rules="saveFormRules" ref="addForm">
				<el-form-item prop="name" label="点名称">
					<el-input v-model="addForm.name" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="点类型" prop="dataType">
					<el-radio-group v-model="addForm.dataType" >
						<el-radio class="radio" :label="0">AI</el-radio>
						<el-radio class="radio" :label="1">DI</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item prop="sn" label="点编号">
					<el-input v-model="addForm.sn" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item prop="address" label="点地址">
					<el-input v-model="addForm.address" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="数据类型"  prop="valueType">
					<el-select   v-model="addForm.valueType" style="width: 300px"> 
						<el-option v-for="(item,index) in valueTypeList" v-bind:key="index" :label="item.name" :value="item.key"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item  label="所属项目"  prop="projectId">
					<div >
						<el-select v-model="addForm.projectId"  filterable placeholder="请选择" style="width: 300px"> 
						    <el-option v-for="item in projectList" v-bind:key="item.id" :label="item.name" :value="item.id"></el-option>
					    </el-select>
					</div>
				</el-form-item>
				<el-form-item label="所属系统"  prop="sysCode">
					<el-select  v-model="addForm.sysCode" placeholder="请选择" style="width: 300px">
				        <el-option v-for="(item,index) in sysAppList" v-bind:key="index" :label="item.name" :value="item.key"></el-option>
				    </el-select>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="cancelAddSubmit">取消</el-button>
				<el-button type="primary" v-bind:disabled="addSubmitButtonDisabled" @click.native="addSubmit" :loading="addLoading">提交</el-button>
			</div>
		</el-dialog>

		<!--编辑界面-->
		<el-dialog title="编辑" v-model="editFormVisible" :close-on-click-modal="false">
			<el-form :model="editForm" label-width="120px" :rules="saveFormRules" ref="editForm">
				<el-form-item prop="name" label="点名称">
					<el-input v-model="editForm.name" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="点类型" prop="dataType">
					<el-radio-group v-model="editForm.dataType" >
						<el-radio class="radio" :label="0">AI</el-radio>
						<el-radio class="radio" :label="1">DI</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item prop="sn" label="点编号">
					<el-input v-model="editForm.sn" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item prop="address" label="点地址">
					<el-input v-model="editForm.address" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="数据类型"  prop="valueType">
					<el-select   v-model="editForm.valueType" style="width: 300px"> 
						<el-option v-for="(item,index) in valueTypeList" v-bind:key="index" :label="item.name" :value="item.key"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item  label="所属项目"  prop="projectId">
					<div >
						<el-select v-model="editForm.projectId"  filterable placeholder="请选择" style="width: 300px"> 
						    <el-option v-for="item in projectList" v-bind:key="item.id" :label="item.name" :value="item.id"></el-option>
					    </el-select>
					</div>
				</el-form-item>
				<el-form-item label="所属系统"  prop="sysCode">
					<el-select  v-model="editForm.sysCode" placeholder="请选择" style="width: 300px">
				        <el-option v-for="(item,index) in sysAppList" v-bind:key="index" :label="item.name" :value="item.key"></el-option>
				    </el-select>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="editFormVisible = false;">取消</el-button>
				<el-button type="primary" v-bind:disabled="editSubmitButtonDisabled"  @click.native="editSubmit" :loading="editLoading">提交</el-button>
			</div>
		</el-dialog>

		<!--屏蔽弹窗-->
		<el-dialog title="屏蔽" v-model="blockFormVisible" :close-on-click-modal="false" @close="cancelBlockSubmit">
			<el-form :model="blockForm" label-width="120px" :rules="blockFormRules" ref="blockForm">
				<el-form-item prop="name" label="点名称">
					 <span >{{blockForm.name}}</span>
				</el-form-item>
				<el-form-item label="点类型:" prop="dataType">
						<span v-if="blockForm.dataType == 0">AI</span>
						<span v-else>DI</span>
				</el-form-item>
				<el-form-item label="屏蔽开始时间" prop="startTime">
					<el-date-picker  v-model="blockForm.startTime" value-format="yyyy-MM-dd HH:mm"  format="yyyy-MM-dd HH:mm" type="datetime"  ></el-date-picker>
				</el-form-item>
				<el-form-item label="屏蔽结束时间" prop="endTime">
					<el-date-picker  v-model="blockForm.endTime" value-format="yyyy-MM-dd HH:mm"  format="yyyy-MM-dd HH:mm" type="datetime"  ></el-date-picker>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="cancelBlockSubmit">取消</el-button>
				<el-button type="primary" v-bind:disabled="blockSubmitButtonDisabled" @click.native="blockSubmit" :loading="addLoading">提交</el-button>
			</div>
		</el-dialog>

		<!--配置弹窗-->
		<el-dialog title="配置" v-model="settingFormVisible" :close-on-click-modal="false" @close="cancelSettingSubmit">
			<el-form :model="settingForm" label-width="120px" :rules="settingFormRules" ref="settingForm">
				<el-form-item prop="name" label="点名称:">
					 <span >{{settingForm.name}}</span>
				</el-form-item>
				<el-form-item label="点类型:" prop="dataType">
						<span v-if="settingForm.dataType == 0">AI</span>
						<span v-else>DI</span>
				</el-form-item>
				<el-form-item label="告警:" prop="alarmType">
					<el-radio-group v-model="settingForm.alarmType" >
						<el-radio class="radio" :label="0">报警</el-radio>
						<el-radio class="radio" :label="-1">预警</el-radio>
						<el-radio v-if="settingForm.dataType == '0'" class="radio" :label="1">预警+报警</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item v-if="settingForm.dataType == '0'" prop="unit" label="单位">
					<el-input v-model="settingForm.unit"  auto-complete="off" style="width: 300px;"></el-input>
				</el-form-item>
				<el-form-item v-if="settingForm.dataType == '0' && (settingForm.alarmType == '0' || settingForm.alarmType == '-1' || settingForm.alarmType == '1')" label="正常范围:" style="display:inline;padding-bottom:30px;">
					<el-input v-model="settingForm.lowerThreshold"  auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
					<label  style="width: 40px; text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">-</label>
					<el-input v-model="settingForm.upperThreshold"  auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
				</el-form-item>
				<el-form-item v-if="settingForm.dataType == '0' &&  settingForm.alarmType == '1'" label="预警范围:" style="display:inline;">
					<el-input v-model="settingForm.earlyLowerThreshold"  auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
					<label  style="width: 40px; text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">-</label>
					<el-input v-model="settingForm.earlyUpperThreshold"  auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
				</el-form-item>
				<el-form-item label="状态说明" v-if="settingForm.dataType == '1'"  prop="explainModel" style="display:inline;">
					<span>0:</span>
					<el-input v-model="settingForm.zeroExplain"  auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
					<span style="padding-left:20px;">1:</span>
					<el-input v-model="settingForm.oneExplain"  auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>

				</el-form-item>
				<el-form-item label="报警状态" v-if="settingForm.dataType == '1'"  prop="explainModel">
					<el-select  v-model="settingForm.explainModel"  placeholder="请选择" style="width: 300px">
				        <el-option  label="无" value="-1"></el-option>
						<el-option  label="0" value="0"></el-option>
						 <el-option  label="1" value="1"></el-option>
						 <el-option  label="01" value="2"></el-option>
				    </el-select>
				</el-form-item>
				<el-form-item  prop="alarmTimeout" label="告警超时:" >
					<el-input v-model="settingForm.alarmTimeout"  auto-complete="off"  placeholder="请输入1-3000的自然数" style="width: 300px"></el-input>
					<label  style="width: 40px; text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">分钟</label>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="cancelSettingSubmit">取消</el-button>
				<el-button type="primary"  v-bind:disabled="settingSubmitButtonDisabled" @click.native="settingSubmit" :loading="addLoading">提交</el-button>
			</div>
		</el-dialog>

		<!--查看配置弹窗-->
		<el-dialog title="查看配置" v-model="showSettingFormVisible" :close-on-click-modal="false" @close="cancelShowSettingSubmit">
			<el-form :model="settingForm" label-width="120px" :rules="settingFormRules" ref="settingForm">
				<el-form-item prop="name" label="点名称:">
					 <span >{{settingForm.name}}</span>
				</el-form-item>
				<el-form-item label="点类型:" prop="dataType">
						<span v-if="settingForm.dataType == 0">AI</span>
						<span v-else>DI</span>
				</el-form-item>
				<el-form-item label="告警:" prop="alarmType">
					<el-radio-group v-model="settingForm.alarmType" disabled>
						<el-radio class="radio" :label="0">报警</el-radio>
						<el-radio class="radio" :label="-1">预警</el-radio>
						<el-radio v-if="settingForm.dataType == '0'" class="radio" :label="1">预警+报警</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item v-if="settingForm.dataType == '0'" prop="unit" label="单位">
					<el-input v-model="settingForm.unit" disabled auto-complete="off" style="width: 300px;"></el-input>
				</el-form-item>
				<el-form-item v-if="settingForm.dataType == '0' && (settingForm.alarmType == '0' || settingForm.alarmType == '1' || settingForm.alarmType == '-1')" label="正常范围:" style="display:inline;padding-bottom:30px;">
					<el-input v-model="settingForm.lowerThreshold" disabled auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
					<label  style="width: 40px; text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">-</label>
					<el-input v-model="settingForm.upperThreshold" disabled auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
				</el-form-item>
				<el-form-item v-if="settingForm.dataType == '0' &&  settingForm.alarmType == '1'" label="预警范围:" style="display:inline;">
					<el-input v-model="settingForm.earlyLowerThreshold" disabled auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
					<label  style="width: 40px; text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">-</label>
					<el-input v-model="settingForm.earlyUpperThreshold" disabled auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
				</el-form-item>
				<el-form-item label="状态说明" v-if="settingForm.dataType == '1'"  prop="explainModel" style="display:inline;">
					<span>0:</span>
					<el-input v-model="settingForm.zeroExplain" disabled auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>
					<span style="padding-left:20px;">1:</span>
					<el-input v-model="settingForm.oneExplain" disabled auto-complete="off" style="width:135px;padding-bottom:30px;"></el-input>

				</el-form-item>
				<el-form-item label="报警状态" v-if="settingForm.dataType == '1'"  prop="explainModel">
					<el-select  v-model="settingForm.explainModel" disabled placeholder="请选择" style="width: 300px">
				        <el-option  label="无" value="-1"></el-option>
						<el-option  label="0" value="0"></el-option>
						 <el-option  label="1" value="1"></el-option>
						 <el-option  label="01" value="2"></el-option>
				    </el-select>
				</el-form-item>
				<el-form-item  prop="alarmTimeout" label="告警超时:" >
					<el-input v-model="settingForm.alarmTimeout" disabled auto-complete="off"   style="width: 300px"></el-input>
					<label  style="width: 40px; text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">分钟</label>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="cancelShowSettingSubmit">取消</el-button>
			</div>
		</el-dialog>
	</section>
</template>

<script>
	import api from '@/api';
	import tools from '@/util/tools';
	import Treeselect from '@riophae/vue-treeselect'
	import global from '@/config/global_config'
	import Vue from 'vue'
	import router from '@/router/index.js'
	
	export default {
		components: { Treeselect },
		watch: {
			filterText(val) {
				this.$refs.projectTree.filter(val);
			}
        },
		data() {
			return {
				userRoleIdentity:global.getCurrentUser().roleIdentity,
				permissionNodeList:global.getPermissionNodeList(),
				filters: {
					name: ''
				},
				list_data: [],
				total: 0,
				page: 1,
				listLoading: false,
				sels: [],
				valueTypeList:[],
				editFormVisible: false,
				editLoading: false,
				saveFormRules: {
					name: [
						{ required: true, message: '点名称不能为空', trigger: 'blur' },
						{ min: 1, max: 32, message: '输入长度在1到32个字符之间'}
					],  
					dataType: [
						{ required: true, message: '请选择点类型'},
					],
					sn: [
						{ required: true, message: '点编号不能为空', trigger: 'blur' },
						{ min: 1, max: 32, message: '输入长度在1到32个字符之间'}
					],
					address: [
						{ required: true, message: '点地址不能为空', trigger: 'blur' },
					],
					valueType:[
						{ required: true, message: '请选择数据类型'},
					],
					projectId:[
					    { required: true, message: '请选择所属项目'},
					],
					sysCode:[
					    { required: true, message: '请选择所属系统'},
					]
				},
				addForm: {

				},
				editForm: {

				},
				filterForm: {
					
				},
				sysAppList:[],
				projectSysSourceList_Original: [],
			    projectSysSourceList: [],
				addFormVisible: false,
				addLoading: false,
				businessGroupIdsSelect:'',
				sysSourceListVisible:false,
				projectTree:[],
				projectTreeDefaultChecked:[],
				filterText:'',
				projectTreeDialogVisible:false,
				projectNames:'',
				projectIds:'',
				shortAcountList:[],
				shortAcountList_tree:[],
				batchImportDialogVisible:false,
				uploadUrl:global.apiBaseURL+'/ba/upload',
				uploadHeader:{access_token:global.getAccessToken()},
				search_word:'',
				bulidYear:'',
				catchTime:'',
				editSubmitButtonDisabled:false,
				addSubmitButtonDisabled:false,
				businessTypeList:[],
				regionAreaList:[],
				tableSelectionIds:'',
				blockFormVisible:false,
				blockForm:{

				},
				blockFormRules:{

				},
				blockSubmitButtonDisabled:false,
				settingFormVisible:false,
				showSettingFormVisible:false,
				settingForm:{

				},
				settingFormRules:{

				},
				settingSubmitButtonDisabled:false,
				filterDataType:'',
				filterSysCode:'',
				projectList:[],
			}
		},
		methods: {
			checkinlist(){
				 console.log(this.editForm.sysIdJoinCodes);
			},
			handleCurrentChange(val) {
				this.page = val;
				this.get_list_data();
			},
			handleSearch(){
				this.get_list_data();
			},
			hiddenSysSourceList(){
				this.sysSourceListVisible = false;
			},
			showSysSourceList(){
				this.sysSourceListVisible = true;
			},
			filterNode(value, data) {
				if (!value) return true;
				return data.label.indexOf(value) !== -1;
			},
			showProjectTree(){
				this.projectTreeDialogVisible = true;
				return;
			},
			projectTreeOnCancel(){
				this.$refs.projectTree.setCheckedNodes([]);
				this.projectTreeDialogVisible = false;
			},
			projectTreeOnSubmit(){
				let leafCheckedNodes = [];
				let leafCheckedNodeNames = [];
				let checkedNodes = this.$refs.projectTree.getCheckedNodes();
				if(checkedNodes){
					checkedNodes.forEach(one => {
						if(!one.children){
							leafCheckedNodes.push(one.id);
							leafCheckedNodeNames.push(one.label);
						}
					});
					this.projectNames = leafCheckedNodeNames.join(',');
					this.projectIds =  leafCheckedNodes.join(',');
				}
				this.projectTreeDialogVisible = false;
			},
			get_list_data() {
				let param = {
					keys:this.search_word,
					pageNum: this.page,
					pageSize: 15
				};
				if(null != this.projectIds && this.projectIds.length>0 )param.projectIds = this.projectIds;
				if(null != this.filterDataType && this.filterDataType.length>0) param.dataType = this.filterDataType;
				if(null != this.filterSysCode && this.filterSysCode.length>0) param.sysCode = this.filterSysCode;
				this.listLoading = true;
				api.assetsManage_ba_getPageList_request(param).then((res) => {
					this.total = res.data.total;
					this.list_data = res.data.list;
					this.listLoading = false;
				}).catch((e) => {
					console.log(e);
					tools.error(new Vue(),e.message);
				});
			},
			cancelBlockSubmit(){
				this.blockFormVisible = false;
				this.$refs.blockForm.resetFields();
				if(this.blockSubmitButtonDisabled)this.blockSubmitButtonDisabled = false;
			},
			handleBlock: function (index, row) {
				this.blockFormVisible = true;
				this.blockForm.name  = row.name;
				this.blockForm.deviceId  = row.deviceId;

			},
			blockSubmit: function () {
				this.$refs.blockForm.validate((valid) => {
					if (valid) {
						this.listLoading = true;
						this.blockSubmitButtonDisabled=true;
						let param = Object.assign({}, this.blockForm);
						if(null != param.startTime){
							param.startTime=param.startTime.getFullYear() + '-' + (param.startTime.getMonth() + 1) + '-' + param.startTime.getDate() + ' ' + param.startTime.getHours() + ':' + param.startTime.getMinutes();
						}
						if(null != param.endTime){
							param.endTime=param.endTime.getFullYear() + '-' + (param.endTime.getMonth() + 1) + '-' + param.endTime.getDate() + ' ' + param.endTime.getHours() + ':' + param.endTime.getMinutes();
						}
						param.alarmIgnoreAble = 1;
						api.assetsManage_ba_setAlarmPolicy_request(param).then(
							res => {
								this.blockFormVisible = false;
								this.$refs.blockForm.resetFields();
								this.blockSubmitButtonDisabled=false;
								tools.success(this,"配置成功");
								this.get_list_data();
							}
						).catch(function (e) {
							console.log(e);
							self.blockSubmitButtonDisabled=false;
							if(e.message)tools.error(new Vue(),e.message);
						});	
					}
				})
			},
			handleUnBlock: function (index, row) {
				this.$confirm('确认取消告警屏蔽?', '提示',{showClose:false}).then(() => {
					let param = { deviceId:row.deviceId,alarmIgnoreAble: 0};
					api.assetsManage_ba_setAlarmPolicy_request(param).then(
						res => {
							tools.success(this,"取消成功");
							this.get_list_data();
						}
					)	
				}).catch((e) => {
					console.log(e);
					if(e.message)tools.error(new Vue(),e.message);
				});
			},
			handleShowSetting: function (index, row) {
				let param = {deviceId:row.deviceId};
				this.listLoading = true;
				api.assetsManage_ba_findInfoByDeviceId_request(param).then((res) => {
					if(res.data){
						this.settingForm = Object.assign({}, res.data);
						if(this.settingForm.dataType == 'AI')this.settingForm.dataType = '0';
						else if(this.settingForm.dataType == 'DI')this.settingForm.dataType = '1';
						this.showSettingFormVisible = true;
					}
					else{
						tools.error(new Vue(),"没有查询到该设备详情,请稍微重试");
					}
				}).catch(function (e) {
					console.log(e);
					if(e.message)tools.error(new Vue(),e.message);
				});
				this.listLoading = false;
			},
			cancelShowSettingSubmit:function () {
				this.showSettingFormVisible = false;
			},
			cancelSettingSubmit(){
				this.settingFormVisible = false;
				for (let index = 0; index < this.$refs.settingForm.fields.length; index++) {
					if((this.$refs.settingForm.fields[index] == undefined) || (this.$refs.settingForm.fields[index].prop == undefined))delete this.$refs.settingForm.fields[index];
				}
				this.$refs.settingForm.resetFields();
				if(this.settingSubmitButtonDisabled)this.settingSubmitButtonDisabled = false;
			},
			handleSetting: function (index, row) {
				let param = {deviceId:row.deviceId};
				this.listLoading = true;
				api.assetsManage_ba_findInfoByDeviceId_request(param).then((res) => {
					if(res.data){
						this.settingForm = Object.assign({}, res.data);
						if(this.settingForm.dataType == 'AI')this.settingForm.dataType = '0';
						else if(this.settingForm.dataType == 'DI')this.settingForm.dataType = '1';
						this.settingFormVisible = true;
					}
					else{
						tools.error(new Vue(),"没有查询到该设备详情,请稍微重试");
					}
				}).catch(function (e) {
					console.log(e);
					if(e.message)tools.error(new Vue(),e.message);
				});
				this.listLoading = false;
			},
			settingSubmit: function () {
				this.$refs.settingForm.validate((valid) => {
					if (valid) {
						if(this.settingForm.dataType == 0){
							if(this.settingForm.alarmType == 0){
								if(tools.strIsEmpty(this.settingForm.lowerThreshold) || tools.strIsEmpty(this.settingForm.upperThreshold)){
									tools.error(new Vue(),"正常范围下限阈值或上限阈值为空");
									return;
								}
								this.settingForm.earlyLowerThreshold = "";
								this.settingForm.earlyUpperThreshold = "";
							}
							else if(this.settingForm.alarmType == -1){
								if(tools.strIsEmpty(this.settingForm.lowerThreshold) || tools.strIsEmpty(this.settingForm.upperThreshold)){
									tools.error(new Vue(),"正常范围下限阈值或上限阈值为空");
									return;
								}
								this.settingForm.earlyLowerThreshold = "";
								this.settingForm.earlyUpperThreshold = "";
							}
							else if(this.settingForm.alarmType == 1){
								if(tools.strIsEmpty(this.settingForm.lowerThreshold) || tools.strIsEmpty(this.settingForm.upperThreshold)){
									tools.error(new Vue(),"正常范围下限阈值或上限阈值为空");
									return;
								}
								if(tools.strIsEmpty(this.settingForm.earlyLowerThreshold) || tools.strIsEmpty(this.settingForm.earlyUpperThreshold)){
									tools.error(new Vue(),"预警范围下限阈值或上限阈值为空");
									return;
								}
							}
						}
						if((!tools.strIsEmpty(this.settingForm.earlyLowerThreshold) && !tools.strIsEmpty(this.settingForm.earlyUpperThreshold) ) && (parseFloat(this.settingForm.earlyLowerThreshold) >= parseFloat(this.settingForm.earlyUpperThreshold))){
							tools.error(new Vue(),"预警范围下限阈值必须小于预警范围上限阈值");
							return;
						}
						if((!tools.strIsEmpty(this.settingForm.lowerThreshold) && !tools.strIsEmpty(this.settingForm.upperThreshold)) && (parseFloat(this.settingForm.lowerThreshold) >= parseFloat(this.settingForm.upperThreshold))){
							tools.error(new Vue(),"正常范围下限阈值必须小于正常范围上限阈值");
							return;
						}
						if((!tools.strIsEmpty(this.settingForm.lowerThreshold) && !tools.strIsEmpty(this.settingForm.upperThreshold) ) && (!tools.strIsEmpty(this.settingForm.earlyLowerThreshold) && !tools.strIsEmpty(this.settingForm.earlyLowerThreshold) )){
							if(parseFloat(this.settingForm.lowerThreshold) <= parseFloat(this.settingForm.earlyLowerThreshold)){
								tools.error(new Vue(),"正常范围下限阈值必须大于预警范围下限阈值");
							    return;
							}
							if(parseFloat(this.settingForm.upperThreshold) >= parseFloat(this.settingForm.earlyUpperThreshold)){
								tools.error(new Vue(),"正常范围上限阈值必须小于预警范围上限阈值");
							    return;
							}
						}
						if(tools.strIsEmpty(this.settingForm.alarmTimeout)){
							tools.error(new Vue(),"告警超时不能为空");
							return;
						}
						if(isNaN(parseInt(this.settingForm.alarmTimeout))){
							tools.error(new Vue(),"告警超时请输入数字");
							return;
						}
						if(parseInt(this.settingForm.alarmTimeout) ==NaN || (parseInt(this.settingForm.alarmTimeout)<1) || (parseInt(this.settingForm.alarmTimeout)>3000)){
							tools.error(new Vue(),"请输入1-3000的自然数");
							return;
						}
						this.listLoading = true;
						this.settingSubmitButtonDisabled=true;
						let param = Object.assign({}, this.settingForm);
						api.assetsManage_ba_setAlarmStatusRule_request(param).then(
							res => {
								this.listLoading = false;
								this.settingFormVisible = false;
								for (let index = 0; index < this.$refs.settingForm.fields.length; index++) {
									if((this.$refs.settingForm.fields[index] == undefined) || (this.$refs.settingForm.fields[index].prop == undefined))delete this.$refs.settingForm.fields[index];
								}
								this.$refs.settingForm.resetFields();
								this.settingSubmitButtonDisabled=false;
								tools.success(this,"配置成功");
								this.get_list_data();
							}
						).catch(function (e) {
							console.log(e);
							self.settingSubmitButtonDisabled=false;
							if(e.message)tools.error(new Vue(),e.message);
							this.listLoading = false;
						});	
					}
				})
			},
			handleEdit: function (index, row) {
				let param = {deviceId:row.deviceId};
				this.listLoading = true;
				api.assetsManage_ba_findInfoByDeviceId_request(param).then((res) => {
					if(res.data){
						this.editForm = Object.assign({}, res.data);
						this.editForm.projectId  = String(this.editForm.projectId);
						this.editForm.dataType = parseFloat(this.editForm.dataType); 
						this.editFormVisible = true;
					}
					else{
						tools.error(new Vue(),"没有查询到该设备详情,请稍微重试");
					}
				}).catch(function (e) {
					console.log(e);
					if(e.message)tools.error(new Vue(),e.message);
				});
				this.listLoading = false;
			},
			queryBtn(){
				let param = Object.assign({}, this.filterForm);
				if(null != param.search_word)this.search_word = param.search_word;
				if(null != param.projectIds)this.projectIds = param.projectIds;
				if(null != param.sysCode){
					if(param.sysCode == 'all')this.filterSysCode = '';
					else this.filterSysCode = param.sysCode;
				}
				if(null != param.dataType){
					if(param.dataType == 'all')this.filterDataType = '';
					else this.filterDataType = param.dataType;
				}
				this.get_list_data();
			},
			handleAdd: function () {
				let param = {};
				this.addFormVisible = true;
				this.addForm = {
					dataType:0,
				};	
			},
			addSubmit: function () {
				this.$refs.addForm.validate((valid) => {
					if (valid) {
						this.addSubmitButtonDisabled=true;
						let param = Object.assign({}, this.addForm);
						if(param.dataType == 0)param.dataType = 'AI';
						else if(param.dataType == 1)param.dataType = 'DI';
						this.listLoading = true;
						let self = this;
						param.projectId = parseFloat(param.projectId);
						api.assetsManage_ba_saveOrUpdate_request(param).then((res) => {
							this.addFormVisible = false;
							this.$refs.addForm.resetFields();
							this.addSubmitButtonDisabled=false;
							tools.success(this,"新增成功");
							this.get_list_data();
						}).catch((e) => {
							console.log(e);
							self.addSubmitButtonDisabled=false;
							tools.error(new Vue(),e.message);
						});
						this.listLoading = false;
					}
				});
			},
			handleSelect(index){
				this.editForm.businessGroupIds = this.businessGroupIdsSelect;
            },
			editSubmit: function () {
				this.$refs.editForm.validate((valid) => {
					if (valid) {
						this.editSubmitButtonDisabled=true;
						let param = Object.assign({}, this.editForm);
						if(param.dataType == 0)param.dataType = 'AI';
						else if(param.dataType == 1)param.dataType = 'DI';
						this.listLoading = true;
						let self = this;
						param.projectId = parseFloat(param.projectId);
						api.assetsManage_ba_saveOrUpdate_request(param).then((res) => {
							this.editFormVisible = false;
							this.$refs.editForm.resetFields();
							this.editSubmitButtonDisabled=false;
							tools.success(this,"修改成功");
							this.get_list_data();
						}).catch((e) => {
							console.log(e);
							self.editSubmitButtonDisabled=false;
							tools.error(new Vue(),e.message);
						});
						this.listLoading = false;
					}
				});
			},
			getSysAppList: function () {
				let param = {};
				api.assetsManage_ba_getSysAppList_request(param).then((res) => {
					this.sysAppList = res.data;	
				}).catch((e) => {
					console.log(e);
				});
			},
			getValueTypeList: function () {
				let param = {};
				api.assetsManage_ba_getValueTypeList_request(param).then((res) => {
					if(res.data){
						this.valueTypeList = res.data;	
					}
				}).catch(function (e) {
					console.log(e);
				});
			},
			getProjectTree: function () {
				let param = {};
				this.listLoading = true;
				api.project_findByAccountIdList_request(param).then((res) => {
					let temp = [];
					this.projectList = [];
					if(res.data){
						for (let index = 0; index < res.data.length; index++) {
							temp[index] = {id:-res.data[index].groupId ,label:res.data[index].groupName,children:[]};
							res.data[index].projectList.forEach(one => {
								temp[index].children.push({id:parseFloat(one.projectId),label:one.projectName});
								this.projectList.push({id:one.projectId,name:one.projectName});
							});
						}
					}
					this.projectTree = temp;
				}).catch(function (e) {
					console.log(e);
                });
				this.listLoading = false;
			},
			getShortAcountList: function (projectId) {
				let param = {projectId:projectId};//identity:'level-three',keys:''
				this.listLoading = true;
				api.project_getProjectAcountAble_request(param).then((res) => {
					let temp = [];
					for (let index = 0; index < res.data.length; index++) {
						temp[index] = {id:res.data[index].id ,label:res.data[index].code};
					}
					this.shortAcountList_tree = temp;
					this.shortAcountList = res.data;	
				}).catch((e) => {
					console.log(e);
				});
				this.listLoading = false;
			},
			handleBatchImport:function () {
				this.batchImportDialogVisible = true;
			},
			handleBatchDelete:function () {
				if(this.tableSelectionIds.length == 0){
					tools.error(this,"请先选择要删除的数据");
					return
				}
				this.$confirm('确认删除吗?', '提示', {showClose:false}).then(() => {
				    let param = {ids:this.tableSelectionIds};
					api.assetsManage_ba_batchRemove_request(param).then(
						res => {
							if(res.code == 200){
								tools.success(this,"删除成功");
							    this.get_list_data();
							}
							else{
								tools.error(new Vue(),res.msg);
							}
						}
					).catch((e) => {
						console.log(e);
						if(e.message)tools.error(new Vue(),e.message);
				    });	
				})
				.catch(function(e) {
					console.log(e);
					if(e.message)tools.error(new Vue(),e.message);
				 });
			},
			downloadTemplate(){
				let param = {};
				api.assetsManage_ba_getImportTemplate_request(param).then((res) => {
					let blob = new Blob([res.data],{type:'application/vnd.ms-excel'});
					let fileLink = document.createElement('a')
					fileLink.href = window.URL.createObjectURL(blob);
					fileLink.download =  'template_assetsManageBaList'+'_' + new Date().getTime() + '.xls'
					fileLink.click();
				}).catch((e) => {
					console.log(e);
					tools.error(new Vue(),e.message);
				});
			},
			handleUploadExceed(files, fileList){
				tools.error(this,'每次只能上传一个文件!');
				return false
			},
			handleBeforeUpload(file) {
				const isLt2M = file.size / 1024 / 1024 < 20;
				if (!isLt2M) {
					tools.error(this,'文件过大,注意不能超过20MB!');
					return false
				}
				let Xls = file.name.split('.');
                if(Xls[1] === 'xls'||Xls[1] === 'xlsx'){
                    return file
                }else {
                    tools.error(this,'上传文件只能是 xls/xlsx 格式!')
                    return false
				}
			},
			batchImportOnSubmit(){
				this.$refs.batchImportUpload.submit();
			},
			cancelUpload(){
				this.batchImportDialogVisible = false;
				this.$refs.batchImportUpload.clearFiles();
			},
			handleUploadSuccess(res,file,fileList){
				if(res.code == 200) {
					tools.success(this,"上传成功");
					this.batchImportDialogVisible = false;
					this.$refs.batchImportUpload.clearFiles();
					this.get_list_data();
				}
                else {
					if(res.code == 402) {
						sessionStorage.removeItem('user');
						sessionStorage.removeItem('localRoutes');
						tools.error(new Vue(),'会话已过期,请重新登录');
						router.push('/login');
						location.reload();
					}
					else{
						let errorMessage = '';
						if(res.errorMap){
							Object.keys(res.errorMap).forEach(key => {
								errorMessage += key+"字段:"+res.errorMap[key]+','
							});
							errorMessage = res.msg + '(详细原因：'+ errorMessage +')';
						}
						else errorMessage = res.msg;
						tools.error(new Vue(),errorMessage);
				    }
				}
			},
			handleUploadError(){
				tools.error(this,res.data.msg);
			},
			handleDataExport:function () {

			},
			selsChange: function (sels) {
				this.sels = sels;
				this.tableSelectionIds = "";
				this.sels.forEach(one => {
					if(this.tableSelectionIds.length == 0){
						this.tableSelectionIds = one.deviceId;
					}
					else
					this.tableSelectionIds = this.tableSelectionIds +","+one.deviceId;
				})
			},
			exportData:function () {
				let param = {
					keys:this.filterForm.search_word,
				};
				if(null != this.projectIds && this.projectIds.length>0 )param.projectIds = this.projectIds;
				if(null != this.filterForm.dataType){
					if(this.filterForm.dataType == 'all')this.filterDataType = '';
					else this.filterDataType = this.filterForm.dataType;
				}
				if(null != this.filterDataType && this.filterDataType.length>0) param.dataType = this.filterDataType;
				if(null != this.filterForm.sysCode){
					if(this.filterForm.sysCode == 'all')this.filterSysCode = '';
					else this.filterSysCode = this.filterForm.sysCode;
				}
				if(null != this.filterSysCode && this.filterSysCode.length>0) param.sysCode = this.filterSysCode;
				this.listLoading = true;
				api.assetsManage_ba_exportData_request(param).then((res) => {
					let blob = new Blob([res.data],{type:'application/vnd.ms-excel'});
					let fileLink = document.createElement('a')
					fileLink.href = window.URL.createObjectURL(blob);
					fileLink.download =  'assetsManageBaList'+'_' + new Date().getTime() + '.xls'
					fileLink.click();
				}).catch((e) => {
					tools.error(new Vue(),e.message);
				});
				this.listLoading = false;
			},
			bulidYearOnChange(val) {  
				this.bulidYear = val;
				if(this.editFormVisible) this.editForm.bulidYear =val;
				else this.addForm.bulidYear =val;
			},
			catchTimeOnChange(val) {  
				this.catchTime = val;
				if(this.editFormVisible) this.editForm.catchTime =val;
				else this.addForm.catchTime =val;
			},
			updateAcountListTreeValue(state, value){
				state.value = value
			},
			cancelAddSubmit(){
				this.addFormVisible = false;
				this.$refs.addForm.resetFields();
				if(this.addSubmitButtonDisabled)this.addSubmitButtonDisabled = false;
			},
			getRegionAreaList: function (query) {
				console.log(query)
				let param = {keys:query};
				this.listLoading = true;
				api.account_getRegionAreaList_request(param).then((res) => {
					if(res.data){
						this.regionAreaList = res.data;
					}
				}).catch(function (e) {
					console.log(e);
				});
				this.listLoading = false;
			}
		},
		mounted() {
			this.get_list_data();
			this.getSysAppList();
			this.getValueTypeList();
			this.getProjectTree();
			this.getShortAcountList(null);
		}
	}

</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// ba_list.vue?3cc89562